import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function About() {
  return (
    <>
      <section className="page-hero compact">
        <p className="eyebrow">About</p>
        <h1>Established in Turkey. Shaped by shipped games. Based in the United Kingdom.</h1>
      </section>
      <section className="section story">
        <div className="section-inner story-grid">
          <article>
            <span>01</span>
            <h2>Established in Turkey</h2>
            <p>SZ Interactive was established in Turkey in 2015 with a focus on creating accessible, technically ambitious independent games.</p>
          </article>
          <article>
            <span>02</span>
            <h2>Reaching a global mobile audience</h2>
            <p>The studio developed and released mobile games, including the Truck Simulator Offroad series, and built an audience reaching tens of millions of players. Our games have reached more than 75 million players around the world.</p>
          </article>
          <article>
            <span>03</span>
            <h2>Moving to the United Kingdom</h2>
            <p>In 2019, SZ Interactive moved to the United Kingdom. This period expanded the studio's focus toward Steam, PC development, co-development, and more narrative and technically ambitious projects.</p>
          </article>
          <article>
            <span>04</span>
            <h2>Built by making</h2>
            <p>SZ Interactive is shaped by practical experience: designing systems, solving production problems, shipping games, studying player behaviour, and carrying lessons from one platform into the next.</p>
          </article>
          <article>
            <span>05</span>
            <h2>Current chapter</h2>
            <p>The studio is currently focused on The Shed, JEFF, PC and Steam development, multiplayer systems, original game concepts, and select technical development and collaboration work.</p>
          </article>
        </div>
      </section>
      <section className="contact-cta">
        <div>
          <p className="eyebrow">Next</p>
          <h2>See the technical background behind the studio.</h2>
        </div>
        <Link className="button secondary" to="/experience">View Experience <ArrowRight size={18} aria-hidden="true" /></Link>
      </section>
    </>
  );
}
